document.addEventListener('DOMContentLoaded', () => {
  // Look for .hamburger
  const hamburger = document.querySelector('.hamburger');
  const subNav = document.querySelector('.c-nav--subnav');
  const body = document.querySelector('body');
  // On click
  hamburger.addEventListener('click', function() {
    // Toggle class "is-active"
    hamburger.classList.toggle('is-active');
    subNav.classList.toggle('is-show');
    body.classList.toggle('no-scroll');
    // Do something else, like open/close menu
  });
  const menuDropdown = document.querySelectorAll('.c-nav__item--dropdown')

  document.addEventListener('click', e => {
    let targetClick = e.target;
    do {
      if (targetClick.classList.contains('c-nav__item--dropdown')) {
        return;
      }

      targetClick = targetClick.parentNode;
    } while(targetClick && targetClick.classList);

    menuDropdown.forEach(m => {
      m.classList.remove('active');
    });
  })
  menuDropdown.forEach(m => {
    m.addEventListener('click', e => {
      m.classList.toggle('active')
    })
  });
})
